import React, { useMemo, useState, useEffect } from 'react';
import { Modal, BlockStack, Card } from '@shopify/polaris';
import { useLockBodyScroll } from '../../../hooks/useLockBodyScroll';
import { OrdersGeneralSection } from './OrdersGeneralSection';
import { OrdersDiscountSection } from './OrdersDiscountSection';
import { OrdersTaxSection } from './OrdersTaxSection';

export function NetSuiteOrdersSettingsModal({ open, onClose, onSave, config, source }) {
  useLockBodyScroll(open);
  const initial = useMemo(() => ({
    order: config?.order || {}
  }), [config]);

  const [local, setLocal] = useState(initial);
  useEffect(() => {
    if (open) setLocal(initial);
  }, [open, initial]);

  const handleSave = () => {
    const normalizedOrder = { ...(local.order || {}) };
    if (!normalizedOrder.taxMode) normalizedOrder.taxMode = 'taxMap';
    onSave?.('orders', { order: normalizedOrder });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Order Settings"
      primaryAction={{ content: 'Save Configuration', onAction: handleSave }}
      secondaryActions={[{ content: 'Cancel', onAction: onClose }]}
    >
      <Modal.Section>
        <BlockStack gap="loose">
          {/* Single unified outlined Polaris Card */}
          <Card sectioned>
            <BlockStack gap="loose">
              <OrdersGeneralSection
                bare
                source={source}
                value={local.order}
                onChange={(v) => setLocal((prev) => ({ ...prev, order: { ...prev.order, ...v } }))}
              />
              <OrdersDiscountSection
                bare
                value={local.order}
                onChange={(v) => setLocal((prev) => ({ ...prev, order: { ...prev.order, ...v } }))}
              />
              <OrdersTaxSection
                bare
                value={local.order}
                onChange={(v) => setLocal((prev) => ({ ...prev, order: { ...prev.order, ...v } }))}
              />
            </BlockStack>
          </Card>
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}
